import { TabType } from '@/components/common/TagTabs/TagTabs';
import BillingAndRenewalsContainer from './BillingAndRenewals/BillingAndRenewals.container';
import BulkContractLinsUpdateTab from './BulkContractLinesUpdate/BulkContractLinsUpdateTab';
import ReasonCodesContainer from './ReasonCodes/ReasonCodes.container';
import ImportingToolContainer from './ImportingTool/ImportingTool.container';

export const settingsTabs: TabType[] = [
  {
    title: 'Billing & Renewals',
    name: 'BILLING-RENEWALS',
    ContentComponent: BillingAndRenewalsContainer
  },
  {
    title: 'Reason Codes',
    name: 'REASON-CODES',
    ContentComponent: ReasonCodesContainer
  },
];

export const importingToolTab: TabType = {
  title: 'Importing Tool',
  name: 'IMPORTING-TOOL',
  ContentComponent: ImportingToolContainer
};

export const bulkUpdateTab: TabType = {

  title: 'Bulk Update',
  name: 'BULK-UPDATE',
  ContentComponent: BulkContractLinsUpdateTab
};